import React from 'react'
import PropTypes from 'prop-types'
import { IconManager, coreIconPack } from '@deseretbook/react-ui'
import ReactJWPlayer from 'react-jw-player'

IconManager.register(coreIconPack)

/**
 * Additional content for product page.
 *
 * @returns {function} Component
 */
export const JWPlayerVideo = ({
  libraryUrl,
  videoUrl,
  videoPoster,
  videoContainerId,
  ...props
}) => {
  return (
    <ReactJWPlayer
      image={videoPoster}
      playerId={videoContainerId}
      playerScript={libraryUrl}
      file={videoUrl}
      {...props}
    />
  )
}

JWPlayerVideo.propTypes = {
  libraryUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  videoPoster: PropTypes.string,
  videoContainerId: PropTypes.string,
}
